import React from 'react'
import { logo, placeholderImg } from '../constants/files'
import { NavLink } from 'react-router-dom'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import MobileHeader from './MobileHeader';

const HeaderHome = () => {
    return (
        <header className=' position-sticky top-0'>

            {/* Mobile Nav */}
            <div className=' bg-black d-md-none d-block'>
                <div className='container-xxl py-2'>
                    <nav className=' row justify-content-between align-items-center'>
                        {/* Logo */}
                        <div className=' col-auto'>
                            <NavLink to={'/'}>
                                <LazyLoadImage 
                                src={logo} 
                                alt='CS COMMUNICATION' 
                                style={{height:'3rem'}} 
                                placeholder={<div className=' w-100 h-100'><img src={placeholderImg} className=' h-100 object-fit-contain' alt='' /></div>}
                                effect="black-and-white"
                                height={'3rem'} />
                            </NavLink>
                        </div>

                        <div className='col-lg-8 col-md-10 col'>
                            {/* Mobile */}
                            <div className='row justify-content-end align-items-center gx-3'>
                                <MobileHeader/>
                            </div>
                        </div>
                    </nav>
                </div>
            </div>


        </header>
    )
}

export default HeaderHome